import { getMediaWithProxy } from '../../../utils';
import type {
  GalleryMediaValue,
  MediaValue,
  VideoMediaValue
} from '../../types';
import type { TiktokResponseItemType } from '../types';

type TiktokMediaValue = Extract<
  MediaValue,
  GalleryMediaValue | VideoMediaValue
>;

export const getTiktokMedia = ({
  id,
  videoEmbed,
  thumbnailURL,
  carousel,
  type = 'video'
}: Partial<TiktokResponseItemType>): TiktokMediaValue => {
  if (type === 'image' && carousel) {
    return {
      type: 'gallery',
      items: carousel.map(({ url }) => ({
        type: 'image',
        src: getMediaWithProxy(url)
      })),
      thumbnail: getMediaWithProxy(thumbnailURL)
    };
  }

  return {
    type: 'video',
    videoEmbed,
    src: `https://www.tiktok.com/embed/v2/${id}`,
    thumbnail: getMediaWithProxy(thumbnailURL)
  };
};
